import { useEffect, useRef, useState } from "react";
import { ChevronRight, Check } from "lucide-react";

import shieldIcon from "../../../assets/images/frame.png";
import checked from "../../../assets/images/checked.png";
import { useNavigate } from "react-router-dom";

const promotions = [
  // {
  //   id: "account",
  //   title: "Verify your phone number",
  //   description: "Verify your phone number to complete purchases and enjoy bonuses.",
  // },
  {
    id: "rewards",
    title: "Refer & Earn",
    description: "Invite friends and earn rewards instantly.",
  },
];

export default function BannerSlider() {
  const [activeIndex, setActiveIndex] = useState(0);
  const flatListRef = useRef(null);
  const intervalRef = useRef(null);
  const navigate = useNavigate()

  // Auto-slide every 5 seconds
  useEffect(() => {
    intervalRef.current = setInterval(() => {
      const nextIndex = (activeIndex + 1) % promotions.length;
      setActiveIndex(nextIndex);
    }, 5000);

    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, [activeIndex]);

  // Scroll to the active slide when activeIndex changes
  useEffect(() => {
    if (flatListRef.current) {
      flatListRef.current.scrollTo({
        left: activeIndex * window.innerWidth,
        behavior: "smooth",
      });
    }
  }, [activeIndex]);

  const handlePress = (screenName) => {
    console.log(`Navigating to: ${screenName}`);
    navigate(`/${screenName}`);
  };

  return (
    <div className="mt-6">
      {/* Slider Container */}
      <div
        ref={flatListRef}
        className="flex overflow-x-auto snap-x snap-mandatory scrollbar-hide scroll-smooth"
        style={{ scrollbarWidth: "none", msOverflowStyle: "none" }}
      >
        {promotions.map((item, index) => (
          <div
            key={item.id}
            className="min-w-full px-4 snap-start"
            style={{ width: "100%" }}
          >
            <button
              onClick={() => handlePress(item.id)}
              className="w-full bg-navy-500 hover:bg-[#334155] transition-all rounded-3xl px-6 py-7 flex items-center active:scale-[0.985]"
            >
              {/* Left Icon */}
              <div className="bg-[#E5E7EB] h-16 w-16 rounded-full flex items-center justify-center mr-5 flex-shrink-0">
                <img
                  src={shieldIcon}
                  alt="Shield"
                  className="h-9 w-9 object-contain"
                />
              </div>

              {/* Content */}
              <div className="flex-1 text-left">
                <h3 className="text-white text-[17px] font-semibold mb-2">
                  {item.title}
                </h3>
                <p className="text-gray-300 text-[13.5px] leading-relaxed">
                  {item.description}
                </p>

                {/* Progress Indicators */}
                <div className="flex items-center gap-3 mt-5">
                  {promotions.map((_, i) => (
                    <div
                      key={i}
                      className={`transition-all duration-300 ${
                        i === activeIndex
                          ? "h-7 w-7 bg-green-600 rounded-full flex items-center justify-center"
                          : "h-2.5 w-2.5 bg-white/80 rounded-full"
                      }`}
                    >
                      {i === activeIndex && (
                        <img
                          src={checked}
                          alt="Checked"
                          className="h-6 w-6"
                        />
                      )}
                    </div>
                  ))}
                </div>
              </div>

              {/* Right Arrow */}
              <ChevronRight
                size={28}
                className="text-white opacity-70 ml-3 flex-shrink-0"
              />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}